declare global {
  interface Window {
    // Eslint disabled - we just need to check if Cypress is defined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cypress?: any;
  }
}

export const isRunningInCypress = !!window?.Cypress;
